<template>
    <modal id="candidate-view-modal"
        size="large"
        v-model="showModal"
        :title="candidate.name_romaji"
        :hide-cancel-button="true"
        :hide-submit-button="true">
        <div class="row">
            <div class="col-md-4">
                <label>{{ $t('avatar') }}</label>
                <div class="form-group">
                    <img v-if="candidate.avatar" :src="fileUrl(candidate.avatar)" alt="" style="width: 120px;">
                </div>
            </div>
            <div class="col-md-12"></div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('name_romaji') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.name_romaji">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('name_katakana') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.name_katakana">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('email') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.email">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('phone') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.phone">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('gender') }}</label>
                    <input type="text" readonly class="form-control" :value="$t(candidate.gender)">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('residence') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.residence_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('clothing_size') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.clothing_size_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('experience') }}</label>
                    <input type="text"
                        readonly
                        class="form-control"
                        :value="candidate.experience == 1 ? $t('Yes') : $t('No')">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('years_in_japan') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.in_japan">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('start_date') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.start">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('station') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.station">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('commuting_time') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.how_long">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('job_broker') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.job_broker">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('fb_link') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.fb_link">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('work_place') }}</label>
                    <input type="text" readonly class="form-control" v-model="work_place">
                </div>
            </div>
            <template v-for="field in fields" v-if="fields.length > 0">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ field.label[locate] || field.label['ja'] }}</label>
                        <a v-if="field.type === 'file' && candidate[field.name]" :href="fileUrl(candidate[field.name])" target="_blank" class="d-block btn btn-primary">
                            {{ candidate[field.name].split('/').pop() }}
                        </a>
                        <input v-else type="text" readonly class="form-control" v-model="candidate[field.name]">
                    </div>
                </div>
            </template>
            <div class="col-md-12"></div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('monday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.monday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('tuesday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.tuesday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('wednesday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.wednesday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('thursday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.thursday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('friday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.friday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('saturday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.saturday_text">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ $t('sunday') }}</label>
                    <input type="text" readonly class="form-control" v-model="candidate.sunday_text">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label>{{ $t('remark') }}</label>
                    <textarea class="form-control" rows="4" readonly>{{ candidate.remark }}</textarea>
                </div>
            </div>

            <div class="col-md-12">
                <div class="form-group" v-if="candidate.files?.length">
                    <label>{{ $t('current_files') }}</label>
                    <div class="img-container">
                        <div class="img-box" v-for="(url, index) in candidate.files" :key="'current-image-' + index">
                            <img v-if="isImage(url)"
                                :src="url"
                                class="img-thumbnail"
                                :title="getFileName(url)"
                            />
                            <div v-else
                                :href="url"
                                target="_blank"
                                class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                                :title="getFileName(url)"
                            >
                                <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                            </div>
                            <div class="img-action">
                                <button type="button"
                                    class="btn btn-sm btn-primary"
                                    @click="viewFile(url)"
                                    :title="$t('view')">
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {axiosGet, urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "CandidateViewModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        candidate: null
    },
    data() {
        return {
            TENANT_BASE_URL,
            fields    : [],
            locate    : window?.appLanguage.toLowerCase(),
            work_place: this.getTranslate(),
        }
    },
    mounted() {
        axiosGet(`${TENANT_BASE_URL}api/attribute/fields/candidate`).then(({data}) => {
            this.fields = data
            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    this.formData[field.name] = '';
                }
            }
        }).catch((error) => {
            this.$toastr.e(error.response.data.message)
        })
    },
    methods: {
        fileUrl(path) {
            return urlGenerator(path)
        },
        getTranslate() {
            if (!this.candidate.work_place) {
                return '';
            }

            if (this.candidate.work_place[this.locate] && this.candidate.work_place[this.locate] !== '') {
                return this.candidate.work_place[this.locate]
            }

            return this.candidate.work_place['ja'] || ''
        }
    }
}
</script>

